import t from '@jetshop/intl';
import React, { useState } from 'react';
import { styled } from 'linaria/react';
import useGeolocation from '@jetshop/core/hooks/useGeolocation';
import { ReactComponent as MapPin } from '../../svg/Map-pin.svg';
import Spinner from '../ui/Spinner';
import { theme } from '../Theme';

const UserLocationContainer = styled('div')`
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 1.5rem;
  text-align: center !important;
  border-bottom: 1px solid ${theme.colors.lightgrey};
  padding-bottom: 80px;

  > div {
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  h2 {
    font-family: ${theme.fonts.primary};
    font-size: 18px;
    font-weight: 600;
    line-height: 23px;
    margin: 16px 0;
    text-align: center;
  }

  .hidden {
    visibility: hidden;
  }
`;

const StyledButton = styled('button')`
  display: flex;
  background: #fff;
  height: auto;
  text-decoration: underline;
  // padding-top: 5px;
  color: #333333;

  align-items: center;

  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.03em;
  svg {
    opacity: 0.5;
    margin-right: 7px;
    width: 22px;
    height: 27px;

    #pin {
      fill: white;
      stroke: #333333;
    }

    #circle {
      fill: white;
      stroke: #333333;
    }
  }

  &:focus {
    outline: none;
  }
`;

const StyledSpinner = styled(Spinner)`
  height: 25px;
  circle.path {
    stroke: ${theme.colors.blue};
  }
`;

const UserLocation = ({ setUserLocation }) => {
  // const [hide, setHide] = useState(false);

  const handlePositionClick = () => {
    setShowSpinner(true);
    getPosition();
  };

  const { getPosition, isAvailable, position } = useGeolocation({
    onSuccess: ({ coords: { latitude, longitude } }) =>
      setUserLocation({ latitude, longitude }),
    onError: err => console.log(err)
  });

  const [showSpinner, setShowSpinner] = useState(false);

  return (
    <UserLocationContainer>
      <div className={isAvailable && position ? ' hidden' : null}>
        <StyledButton
          onClick={() => {
            handlePositionClick();
          }}
        >
          {showSpinner ? <StyledSpinner /> : <MapPin />}
          {showSpinner ? t('Searching') : t('Search based on your position')}
        </StyledButton>
      </div>
    </UserLocationContainer>
  );
};

export default UserLocation;
